// extracted by mini-css-extract-plugin
export var aboutUsContact = "aboutUs-module--about-us-contact--4202b";
export var aboutUsFaq = "aboutUs-module--about-us-faq--da343";
export var aboutUsFaqCard = "aboutUs-module--about-us-faq-card--0bd5b";
export var aboutUsFaqCardContent = "aboutUs-module--about-us-faq-card-content--ba0a9";
export var aboutUsFaqCardHeader = "aboutUs-module--about-us-faq-card-header--0bc9d";
export var aboutUsFaqCardTitle = "aboutUs-module--about-us-faq-card-title--2c2b2";
export var aboutUsVideo = "aboutUs-module--about-us-video--48208";
export var aboutUsWrapAboveText = "aboutUs-module--about-us-wrap-above-text--e1650";
export var active = "aboutUs-module--active--e0cb1";
export var contact = "aboutUs-module--contact--e556e";
export var contactCard = "aboutUs-module--contact-card--f7067";
export var contactCardAddress = "aboutUs-module--contact-card-address--1f5c1";
export var contactCardContent = "aboutUs-module--contact-card-content--8eefa";
export var contactCardEmail = "aboutUs-module--contact-card-email--cd7d6";
export var contactCardNumber = "aboutUs-module--contact-card-number--b9fac";
export var contactCardTitle = "aboutUs-module--contact-card-title--6aa63";
export var contactForm = "aboutUs-module--contact-form--1409b";
export var visible = "aboutUs-module--visible--887ff";
export var weddingPackage = "aboutUs-module--wedding-package--bcc0a";
export var wrapAboveContent = "aboutUs-module--wrap-above-content--19d34";